import React from 'react';
import { Title } from '@gjensidige/core-typography';
import utils from '@gjensidige/core-utilities-css';
import classNames from 'classnames';
export const QuestionTitle = ({ className, tag = 'h3', size = 'h4', children }) => (React.createElement(Title, { tag: tag, size: size, className: classNames(className, utils['mb-2']) }, children));
